import { asArray, bName, bUnit, bDetailNote, isOverheadLine } from './billing.js'
import { htmlToText } from './html-utils.js'

/* What happened at one visit, in a few words — the recall drawer's การรักษา rows (Ram,
 * 2026-10-30: "add treatment details, so you can quickly understand what's going on in
 * that treatment"). Read from what the drawer already loads, no new request:
 *   billing[]  what was billed (GET /treatment?type=patient nests it): item ×units and
 *              the line's own note (often the teeth). The per-visit fees are left out.
 *   chart.hx[] what the doctor wrote: cc (Chief Complaint) from the first entry, every
 *              entry's PE (Oral Exam & Treatment, rich text) as plain text, N/V from the
 *              first entry. A chart with no hx[] falls back to the older `history` object.
 *   detail / remark on the visit, and each entry's note.
 * Every field comes back as plain text ('' / [] when absent) — the cell decides what
 * to show. */
export function treatmentSummary(t, chart) {
  const items = []
  for (const b of asArray(t?.billing)) {
    if (!b || b.active === false || isOverheadLine(b)) continue
    const name = bName(b)
    const note = bDetailNote(b)
    if (name === 'รายการ' && !note) continue // bName's fallback: a line with no name at all
    const unit = bUnit(b)
    const s = `${name}${unit > 1 ? ` ×${unit}` : ''}${note && note !== name ? ` (${note})` : ''}`
    if (!items.includes(s)) items.push(s)
  }

  const hx = asArray(chart?.hx).filter(Boolean)
  const legacy = chart?.history && typeof chart.history === 'object' ? chart.history : null
  const entries = hx.length ? hx : legacy ? [legacy] : []
  const notes = []
  for (const v of [t?.detail, t?.remark, ...entries.map((e) => e.note)]) {
    const s = htmlToText(v)
    if (s && !notes.includes(s)) notes.push(s)
  }
  return {
    items,
    cc: htmlToText(entries[0]?.cc),
    exam: entries.map((e) => htmlToText(e.PE)).filter(Boolean).join(' · '),
    nv: htmlToText(entries[0]?.NV),
    notes,
  }
}
